var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.931 5.09065C13.1855 5.21781 13.466 5.28401 13.7505 5.28401C14.035 5.28401 14.3155 5.21781 14.57 5.09065L17.9241 3.41315C18.0639 3.34326 18.2193 3.31031 18.3755 3.31742C18.5317 3.32454 18.6835 3.37148 18.8164 3.45379C18.9493 3.5361 19.059 3.65104 19.135 3.78768C19.211 3.92433 19.2507 4.07814 19.2505 4.23448V15.9348C19.2504 16.105 19.2029 16.2718 19.1134 16.4165C19.0239 16.5613 18.8958 16.6782 18.7436 16.7543L14.57 18.8416C14.3155 18.9687 14.035 19.0349 13.7505 19.0349C13.466 19.0349 13.1855 18.9687 12.931 18.8416L9.06999 16.9111C8.81552 16.7839 8.53496 16.7177 8.25049 16.7177C7.96602 16.7177 7.68546 16.7839 7.43099 16.9111L4.07691 18.5886C3.93698 18.6585 3.78149 18.6914 3.62523 18.6843C3.46896 18.6771 3.31713 18.6301 3.18418 18.5477C3.05123 18.4653 2.94158 18.3502 2.86567 18.2134C2.78975 18.0767 2.75011 17.9227 2.75049 17.7663V6.0669C2.75058 5.89671 2.79805 5.72991 2.88758 5.58517C2.97711 5.44043 3.10517 5.32348 3.25741 5.2474L7.43099 3.16015C7.68546 3.03299 7.96602 2.9668 8.25049 2.9668C8.53496 2.9668 8.81552 3.03299 9.06999 3.16015L12.931 5.09065Z",
    stroke: "#FFFDF1",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 5.28223V19.0322",
    stroke: "#FFFDF1",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24951 2.9668V16.7168",
    stroke: "#FFFDF1",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.5e1c6cf5f287d35f8381c9a752c29541.svg";
export { ForwardRef as ReactComponent };